import React from "react";
import { useMap } from "react-leaflet";
import "../css/mapPage.css";
import "../css/GCPillButton.css";
import { useLanguage } from "../components/Language.js";

function CentreMapOnUser({lat,long}){
    const map = useMap();
    const {language} = useLanguage();

    const translations = {
        en: {
            findMe: "Find Me!",
            
        },
        gd: {
            findMe: "Lorg mi!",
            
        },
    };

    const handleCentreMap = () => {
        if (lat && long){
            map.flyTo([lat, long], 15)
        }
    };

    return(
        <div>
            <button onClick = {handleCentreMap} className="location-load-buttons findme-button GCPillbutton">{translations[language].findMe}</button>
        </div>
    );
}

export default CentreMapOnUser; 